export const ANALYTICS_CONSENT_STORAGE_KEY = "veritrellis_analytics_consent";
